<template>
    <div :class="`adv-bannr ${layoutType} ${showDesktop ? '' : 'mobile'}`">
        <div v-if="subscriptionAllowed && layoutType == 'default'" class="ad-itm">
            <div class="title-wrap">
                <h3>{{ 'Become a' | translate }}</h3>
            </div>
            <div class="content-wrap">
                <h3>{{ 'PREMIUM MEMBER' | translate }}</h3>
                <div class="detail-wrap">
                    <h4>{{ 'And get' | translate }} <br/>
                    {{ 'more views' | translate }}</h4>
                    <div class="star-wrapper">
                        <i class="icon icon-star"></i>
                        <i class="icon icon-star"></i>
                        <i class="icon icon-star"></i>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="layoutType == 'profile'" class="ad-itm">
            <div class="info-wrap">
                <h6><span>{{ 'Boost' | translate | normalize }}</span>
                {{ 'your profile' | translate | normalize }}</h6>
                <img v-if="!showDesktop" :src="`${cdn_url}/images/dance.svg`" class="img-responsive mobile-img">
                <h6>{{ 'And get' | translate | normalize }} <br/>
                    {{ 'more views' | translate | normalize }}</h6>
                <button class="btn btn-white">{{ 'boost' | translate }}</button>
            </div>
            <div class="img-wrap" v-if="showDesktop">
                <img :src="`${cdn_url}/images/dance.svg`" class="img-responsive">
            </div>
        </div>
        <div v-if="layoutType == 'multiple'" class="ad-itm">
            <img v-for="(val, key) in banners" :src="`${cdn_url}${val.img}`" v-show="key == ibs"  @click="clickToRedirect(val.link)" class="img-responsive">
        </div>
    </div>
</template>

<script>
	import AdvBannr from '@views/user/partials/AdvBannr/adv_bannr'

	export default {
		mixins: [AdvBannr]
	}
</script>

<style lang="scss" src="./adv_bannr.scss"></style>
